// React y Hooks
import React, { useState, useEffect, useMemo } from 'react'
// Third-party libraries
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DataTable from 'react-data-table-component'
import Modal from 'antd/es/modal';
import 'antd/dist/antd.css'
import { useTranslation } from 'react-i18next'
// Material UI components
import Container from '@material-ui/core/Container'
import { Grid, Backdrop, CircularProgress } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
// Internal/common components
import TopBarNav from '../common/TopBarNav'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import TableFilterComponentOtherTransactions from '../common/TableFilterComponentOtherTransactions'
import UseForm from '../common/UseForm'
// Redux actions
import * as navigationActions from '../../actions/common/NavigationActions'
import * as OrderActions from "../../actions/othertransactions/OrderActions"
import * as CatalogActions from '../../actions/catalog/CatalogActions'
// Local files
import { ColumnsOrderList,FiltersHeaders } from './ColumnsOrderList'

import { OtherTransactionsStyles } from './OtherTransactionsStyles'
import { customStylePrincipalOrder } from '../common/CommonStyles'
import './othertransactions.css'
import { ToastContainer, toast } from 'react-toastify'
// Opciones para notificaciones (Toast)
const optionsToast = {
    position: 'top-right',
    autoClose: 5000,
};
// Enumeración para tipos de notificación
const enumToast = {
    Error: 'error',
    Warning: 'warning',
    Info: 'info',
    Success: 'success',
};
const OrdersList = ({ classes, ...props }) => {
    // Routing
    const history = useHistory()
    // UI states
    const [openBackdrop, setOpenBackdrop] = useState(false);
    //Get params from url
    const { match: { params } } = props
    //Language
    const { t, i18n } = useTranslation()
    // Configuración of pagination for DataTable
    const paginationOptions = {
        rowsPerPageText: t('commonMessages.rowsPerPage'),
        rangeSeparatorText: t('common.to'),
        selectAllRowsItem: false,
        selectAllRowsItemText: t('common.all')
    }
    // Pagination & data table
    const [data, setData] = useState([])
    const [totalRows, setTotalRows] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false)
    const [nameSuppplier, setNameSuppplier] = useState('')
    // Filter-related
    const [filterText, setFilterText] = useState('')
    const [filterValues, setFilterValues] = useState({
        filterText: '',
        Page: 1,
        RowsPerPage: 10,
        OrderByColumn: 'PymtOrdId',
        OrderBy: 'desc',
        SupplierId: parseInt(params.branchOfficeId)
    })
    const [paginationRows, setPaginationRows] = useState([])
    const [hasFilter, setHasFilter] = useState(false)

    // Form state for filters
    const initialFieldValues = {
        startDate: '',
        endDate: '',
        service: [],
        status: [],
        vin: ''
    }
    const {
        values,
        setValues,
        resetForm, handleInputChange,
        handleSearchMultipleBoxChange
    } = UseForm(initialFieldValues)

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    //Update route names when change the lenguage
    useEffect(() => {
        props.navigationActions.clean_routes()

        const newRoute = {
            path: '/othertransactions',
            linkLegend: t('OtherTransactions'),
            urlParams: [{ key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRoute)

        const newRouteOrders = {
            path: '/othertransactions/listOrders',
            linkLegend: t(`OrderDashboard.Orders`),
            urlParams: [{ key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRouteOrders)
    }, [t])

    //Fetch Services & Status List on Mount  
    useEffect(() => {
        setPaginationRows([10, 15, 20, 25, 30, 50, 100, 200,500]);
        props.catalogActions.fetch_supplier_by_id(
            props.userLanguage,
            props.userToken,
            params.branchOfficeId,
            () => (''),
            onSuccessSupplier
        )

        props.catalogActions.fetch_contract_service_code(
            props.userLanguage,
            props.userToken,
            params.branchOfficeId,
            () => (''),
            () => ('')
        )

        props.catalogActions.fetch_status(
            () => ('')
        )
    }, []);
    //On success supplier info
    const onSuccessSupplier = (response) => {
        setNameSuppplier(response.description);
    };

    //Fetch Orders
    const fetchOrders = async (params, cleanFilters = false) => {
        handleOpenBackdrop();
        let filterValues = cleanFilters ? {
            startDate: '',
            endDate: '',
            service: [],
            status: [],
            vin: ''
        }
            : values
        setHasFilter(filterValues.startDate !== '' || filterValues.endDate !== '' || filterValues.status.length > 0 || filterValues.service.length > 0 || filterValues.vin !== '')

        const statusOrder = filterValues.status.map(d => d.id);
        const service = filterValues.service.map(d => d.contractSvcCd);

        await props.orderActions.fetch_order_list_Page(
            props.userLanguage,
            props.userToken,
            {
                ...params,
                Status: statusOrder,
                Service: service,
                StartDate: filterValues.startDate || null,
                EndDate: filterValues.endDate || null,
                Vin: filterValues.vin
            },
            onError,
            onSuccess,
            "órdenes")
    };
    //Handle Success Response
    const onSuccess = (response) => {
        setData(response.results);
        setTotalRows(response.rowCount);
        handleCloseBackdrop();
    }
    //Handle API Errors
    const onError = (err, extraInfo) => {
        handleCloseBackdrop()

        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    return;
                case 403:
                    history.push('/forbidden')
                    return;
                default:
                    break
            }
        }
        Modal.error({
            title: 'Error',
            content: t('commonMessages.alert500')
        })
    }
    //Handle Page Change
    const handlePageChange = page => {
        setTimeout(function () {
            setCurrentPage(page);
        });
    };
    //Sync Pagination with API Calls
    useEffect(() => {
        if (filterValues.page !== currentPage) {
            const updatedValues = { ...filterValues, Page: currentPage };
            setFilterValues(updatedValues);
            fetchOrders(updatedValues);
        }
    }, [currentPage]);
    //Change Rows Per Page
    const handlePerRowsChange = async (newPerPage, page) => {
        const updatedValues = { ...filterValues, Page: page, RowsPerPage: newPerPage };
        setFilterValues(updatedValues);
        fetchOrders(updatedValues);
    };
    //Handle Sorting
    const handleSort = (column, sortDirection) => {
        const updatedValues = {
            ...filterValues,
            Page: 1,
            OrderByColumn: column.selector,
            OrderBy: sortDirection
        };
        setFilterValues(updatedValues);
        fetchOrders(updatedValues);
    };
    //Search & Filter Actions
    const SendToFilter = () => {
        const updatedValues = { ...filterValues, Page: 1 };
        setCurrentPage(1);
        fetchOrders(updatedValues);
    }

    const handleClear = () => {
        if (filterValues.filterText) {
            setResetPaginationToggle(!resetPaginationToggle);
            const updatedValues = { ...filterValues, filterText: '', Page: 1 };
            setCurrentPage(1);
            setFilterValues(updatedValues);
            fetchOrders(updatedValues);
        }
        setFilterText('');
    }

    const handleSearchFilter = () => {
        setResetPaginationToggle(!resetPaginationToggle);
        const updatedValues = { ...filterValues, filterText: filterText, Page: 1 };
        setCurrentPage(1);
        setFilterValues(updatedValues);
        fetchOrders(updatedValues);
    }

    const ClearFiltered = () => {
        resetForm();
        fetchOrders(filterValues, true);
    }
    //Dowload Excel Filter Actions
    const DownloadExcel = async () => {
        const colums = ColumnsOrderList(t, params.branchOfficeId);
        const columsFilter = FiltersHeaders(t);
        const columnsName = colums
            .filter(obj => obj.hasOwnProperty('name') && typeof obj.name === 'string')
            .map(obj => obj.name);
        const columnsNameFilter = columsFilter
            .filter(obj => obj.hasOwnProperty('name') && typeof obj.name === 'string')
            .map(obj => obj.name); 
        handleOpenBackdrop();
        var filterOrder = { ...values }
        setHasFilter(filterOrder.startDate !== '' || filterOrder.endDate !== '' || filterOrder.status.length > 0 || filterOrder.service.length > 0 || filterOrder.vin !== '')
        const statusOrder = filterOrder.status.map(d => d.id);
        const service = filterOrder.service.map(d => d.contractSvcCd);
        const statusOrderStr = filterOrder.status.map(d => d.description);

        await props.orderActions.DownloadExcel(
            props.userLanguage,
            props.userToken,
            {
                ...filterValues,
                Status: statusOrder,
                StatusStr: statusOrderStr,
                Service: service,
                StartDate: filterOrder.startDate || null,
                EndDate: filterOrder.endDate || null,
                Vin: filterOrder.vin,
                Headers:columnsName,
                HeaderFilter:columnsNameFilter
            },
            onErrorDownloasExcel,
            onSuccessDownloadExcel,
            "órdenes")
    }
    //Handle Success Response Download excel orders
    const onSuccessDownloadExcel = () => {
        handleCloseBackdrop();
    }
    const onErrorDownloasExcel = (err, source) => {
        if (err.response?.status === 401) {
            props.tokenExpired();
            window.location.reload();
        }

        handleCloseBackdrop();
        toast(t('commonMessages.errorDownloadExcel'), {
            ...optionsToast,
            type: enumToast.Error,
        });
        console.log(err);
    };
    const subHeaderComponentMemo = useMemo(() => {
        return <TableFilterComponentOtherTransactions
            onFilter={e => setFilterText(e.target.value)}
            onClear={handleClear}
            filterText={filterText}
            SearchFilter={handleSearchFilter}
            name={nameSuppplier}
            styles={classes.searchAlign}
            allowFilter
            allowTextFilter
            module='orders'
            SendToFilter={SendToFilter}
            ClearFiltered={ClearFiltered}
            SearchButton='Visible'
            handleSearchMultipleBoxChange={handleSearchMultipleBoxChange}
            ordersFilterData={values}
            setOrdersFilterData={setValues}
            hasFilter={hasFilter}
            allowUploadOrders
            allowDownload={!(data.length > 0)}
            onExport={DownloadExcel}
        />;
    }, [props]);

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid item xs={12}>
                    <br />
                </Grid>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}></Grid>
                </Grid>
                <Grid>
                    <DataTable
                        columns={ColumnsOrderList(t, params.branchOfficeId)}
                        data={data}
                        sortServer
                        onSort={handleSort}
                        persistTableHead
                        pagination
                        paginationServer
                        paginationComponentOptions={paginationOptions}
                        paginationTotalRows={totalRows}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        customStyles={customStylePrincipalOrder}
                        highlightOnHover
                        pointerOnHover
                        responsive
                        striped
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                        noHeader
                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                        paginationResetDefaultPage={resetPaginationToggle}
                        paginationRowsPerPageOptions={paginationRows}
                    />
                </Grid>
                <br />
            </Container>
            <ToastContainer />
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language,
    OrderListPage: state.OrderReducer.OrderListPage,
    status: state.CatalogReducer.Status,
    contractServiceCode: state.CatalogReducer.ContractServiceCode
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        orderActions: bindActionCreators(OrderActions, dispatch),
        catalogActions: bindActionCreators(CatalogActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(OtherTransactionsStyles)(OrdersList))